import { render, staticRenderFns } from "./McmContent.vue?vue&type=template&id=cb02aba6&scoped=true"
import script from "./McmContent.vue?vue&type=script&lang=ts"
export * from "./McmContent.vue?vue&type=script&lang=ts"
import style0 from "./McmContent.vue?vue&type=style&index=0&id=cb02aba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb02aba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
